import styled from "styled-components";

const Link = styled.a`
  color: var(--link-color-primary-600-color, var(--theme-primary-700));
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  position: relative;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  text-align: left;

  &:focus {
    outline: none;
  }

  &:focus {
    padding: 2px 4px;
    border-radius: 4px;
    border: 1px solid
      var(--link-color-primary-600-border-color, var(--theme-primary-700));
  }

  &:hover:not(:focus):after {
    content: "";
    position: absolute;
    height: 1px;
    bottom: 1px;
    left: 0;
    right: 0;
    display: inline-block;
    background-color: var(
      --link-color-primary-100-background-color,
      var(--color-primary-100)
    );
  }
`;

export default Link;
